var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.delivery && _vm.delivery.status === 'paused')?_c('p',{staticClass:"px-6 py-3 text-sm text-red-500",attrs:{"role":"status","data-cy":"autoplug-delivery-warning"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }